import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';

import ModalDecorator from 'hocs/ModalDecorator';
import SignUpForm from 'components/forms/Auth/SignUpForm';
import withGoogleHandle from 'hocs/withGoogleHandle';

import ModalButton from '../ModalButton/ModalButton';

class SignUpModal extends Component {
  constructor() {
    super();

    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#signup-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#signup-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#signup-modal').modal('hide');
  };

  handleGoogle = () => {
    const { modalProps, signUpWithGoogle } = this.props;

    signUpWithGoogle({
      bookingData: modalProps.bookingData,
      success: this.handleSignUpSuccess,
    });
  };

  handleSignUpSuccess = () => {
    this.close();
  };

  render() {
    const { modalProps } = this.props;

    return (
      <div
        id="signup-modal"
        className="SignUpModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="signup-label"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered mx-auto"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body text-center p-4 p-sm-5">
              <h3 className="mt-4 mb-4">Create your account</h3>
              <SignUpForm
                gapiReady={this.props.gapiReady}
                onGoogle={this.handleGoogle}
                onSuccess={this.handleSignUpSuccess}
                bookingData={modalProps.bookingData}
              />

              <div className="d-flex align-items-center justify-content-between my-4">
                <p className="my-0">Already a member?</p>
                <ModalButton
                  type="button"
                  modalId="login-modal"
                  className="btn btn-secondary btn-lg btn-cursor btn-rype-outline"
                  modalProps={modalProps}
                >
                  Login
                </ModalButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
  };
}

export default compose(
  withGoogleHandle,
  ModalDecorator('signup-modal'),
  connect(mapStateToProps)
)(SignUpModal);



// WEBPACK FOOTER //
// ./src/components/modals/SignUpModal/index.js